<template>
  <svg :height="size || 32" :width="size || 32" v-bind="$attrs" viewBox="0 0 24 24">
    <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m-2 15l-5-5l1.41-1.41L10 14.17l7.59-7.59L19 8z"
          fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: 'CheckCircleIcon',
  props: {
    size: Number,
  },
};
</script>

